var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({staticClass:"feather feather-play",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},_vm.$listeners),[_c('path',{attrs:{"d":"M5 3l14 9-14 9V3z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }